
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppBreadcrumbsComponent } from '../app-breadcrumbs/app-breadcrumbs.component';
import { AppHeaderComponent } from '../app-header/app-header.component';
import { AppSidebarComponent } from '../app-sidebar/app-sidebar.component';
import { AppFooterComponent } from '../app-footer/app-footer.component';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  templateUrl: './full-layout.component.html',
  imports: [RouterModule, AppBreadcrumbsComponent, AppHeaderComponent, AppSidebarComponent, AppFooterComponent]
})
export class FullLayoutComponent { }
